module.exports = __webpack_public_path__ + "img/2.252b9741.png";